import React from 'react';
import MessageContent from 'components/messages/MessageContent';
import Message from 'components/Message';

const SendCodeSuccess = ({ onDismiss }) => (
  <Message
    type="info"
    onDismiss={onDismiss}
    message={(
      <MessageContent>Email Sent! please check your inbox &amp; junk folder.</MessageContent>
    )}
  />
);

SendCodeSuccess.displayName = 'SendCodeSuccess';

SendCodeSuccess.propTypes = {
  onDismiss: Message.propTypes.onDismiss.isRequired,
};

export default SendCodeSuccess;
